import type { BookingReservationInvoiceLookup } from '../Types/bookingReservationTable.types';
import { mapReservationInvoiceToBookingReservationInvoiceLookup } from './bookingReservationInvoicesLookupMapper';

type BookingReservationInvoiceLookupSource =
  Parameters<typeof mapReservationInvoiceToBookingReservationInvoiceLookup>[0];

export const mapBookingReservationInvoicesLookup = (
  invoices: BookingReservationInvoiceLookupSource[] | undefined
): BookingReservationInvoiceLookup[] =>
  (invoices ?? [])
    .map((invoice) => mapReservationInvoiceToBookingReservationInvoiceLookup(invoice))
    .filter((item): item is BookingReservationInvoiceLookup => item !== undefined);
